var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("AlternativeDetailsDialog", {
        attrs: { viewModel: _vm.alternativeDetailsDialog },
      }),
      _vm._v(" "),
      _c("AttributeDescriptionDialog", {
        attrs: { viewModel: _vm.attributeDescriptionDialog },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        !_vm.Initialized
          ? _c("h3", { staticClass: "text-center" }, [
              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
              _vm._v(" Loading..."),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.Initialized
          ? _c("div", [
              _c(
                "nav",
                { staticClass: "navbar fixed-bottom navbar-dark bg-dark" },
                [
                  _c(
                    "div",
                    { staticClass: "container d-flex justify-content-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "btn-group", attrs: { role: "group" } },
                        [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: _vm.PrevAlternativeUrl,
                                  expression: "PrevAlternativeUrl",
                                },
                              ],
                              staticClass: "btn btn-secondary",
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-angle-double-left",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v("\n                            Prev "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-lowercase d-none d-sm-inline",
                                },
                                [_vm._v(_vm._s(_vm.AlternativeLabel))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-warning",
                              attrs: { type: "button" },
                              on: { click: _vm.ScrollTopCommand },
                            },
                            [
                              _vm._v(
                                "\n                            Back to Top\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: _vm.NextAlternativeUrl,
                                  expression: "NextAlternativeUrl",
                                },
                              ],
                              staticClass: "btn btn-secondary",
                            },
                            [
                              _vm._v("\n                            Next "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-lowercase d-none d-sm-inline",
                                },
                                [_vm._v(_vm._s(_vm.AlternativeLabel))]
                              ),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa fa-angle-double-right",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "nav",
                {
                  staticClass:
                    "navbar navbar-expand-md navbar-dark bg-dark fixed-top",
                },
                [
                  _c("div", { staticClass: "container" }, [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: _vm.DashboardUrl,
                            expression: "DashboardUrl",
                          },
                        ],
                        staticClass: "btn btn-light mr-auto",
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-double-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(
                          "\n                        My Survey\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "progress mx-2 w-50",
                        staticStyle: {
                          height: "38px",
                          "background-color": "#D3D3D3",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "progress-bar",
                            style: { width: _vm.Progress + "%" },
                            attrs: { role: "progressbar" },
                          },
                          [_vm._v(_vm._s(_vm.ProgressStr))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.IsSaved == null,
                            expression: "IsSaved == null",
                          },
                        ],
                        staticClass: "btn btn-warning",
                        attrs: { type: "button" },
                        on: { click: _vm.Save },
                      },
                      [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(" Saving...\n                    "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.IsSaved === true,
                            expression: "IsSaved === true",
                          },
                        ],
                        staticClass: "btn btn-light",
                        attrs: { type: "button" },
                        on: { click: _vm.Save },
                      },
                      [
                        _vm._v(
                          "\n                        Saved\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.IsSaved === false,
                            expression: "IsSaved === false",
                          },
                        ],
                        staticClass: "btn btn-warning",
                        attrs: { type: "button" },
                        on: { click: _vm.Save },
                      },
                      [
                        _vm._v(
                          "\n                        Save\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "padding-top": "80px",
                    "padding-bottom": "120px",
                  },
                },
                [
                  _c("h3", { staticClass: "mt-4", attrs: { id: "top" } }, [
                    _c("span", { staticClass: "font-weight-light" }, [
                      _vm._v("Evaluate "),
                      _c("span", { staticClass: "text-lowercase" }, [
                        _vm._v(_vm._s(_vm.AlternativeLabel)),
                      ]),
                      _vm._v(": "),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.Name))]),
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "nav",
                    {
                      staticClass:
                        "navbar navbar-expand-md navbar-light bg-light",
                    },
                    [
                      _c("ul", { staticClass: "navbar-nav" }, [
                        _c("li", { staticClass: "nav-item dropdown" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link dropdown-toggle",
                              attrs: {
                                id: "navbarDropdown",
                                role: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                Questions: "
                              ),
                              _c("span", [_vm._v(_vm._s(_vm.QuestionsFilter))]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.SetQuestionsFilterCommand("All")
                                  },
                                },
                              },
                              [
                                _vm._v("All "),
                                _c(
                                  "span",
                                  { staticClass: "badge badge-secondary" },
                                  [_vm._v(_vm._s(_vm.QuestionsCount))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-divider" }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.SetQuestionsFilterCommand(
                                      "Answered"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v("Answered "),
                                _c(
                                  "span",
                                  { staticClass: "badge badge-secondary" },
                                  [_vm._v(_vm._s(_vm.AnsweredQuestionsCount))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.SetQuestionsFilterCommand(
                                      "Not answered"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v("Not answered "),
                                _c(
                                  "span",
                                  { staticClass: "badge badge-secondary" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.NotAnsweredQuestionsCount)
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-divider" }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.SetQuestionsFilterCommand(
                                      "Has value"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v("Has value "),
                                _c(
                                  "span",
                                  { staticClass: "badge badge-secondary" },
                                  [_vm._v(_vm._s(_vm.VotedQuestionsCount))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.SetQuestionsFilterCommand(
                                      "No value"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v("No value "),
                                _c(
                                  "span",
                                  { staticClass: "badge badge-secondary" },
                                  [_vm._v(_vm._s(_vm.NotVotedQuestionsCount))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-divider" }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.SetQuestionsFilterCommand(
                                      "Commented"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v("Commented "),
                                _c(
                                  "span",
                                  { staticClass: "badge badge-secondary" },
                                  [_vm._v(_vm._s(_vm.CommentedQuestionsCount))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.SetQuestionsFilterCommand(
                                      "Not commented"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v("Not commented "),
                                _c(
                                  "span",
                                  { staticClass: "badge badge-secondary" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.NotCommentedQuestionsCount)
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "form",
                        { staticClass: "form-inline my-2 my-lg-0 ml-auto" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.SearchPhrase,
                                expression: "SearchPhrase",
                              },
                            ],
                            staticClass: "form-control mr-sm-2",
                            attrs: {
                              type: "search",
                              placeholder: "Filter attributes",
                            },
                            domProps: { value: _vm.SearchPhrase },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.SearchPhrase = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.QuestionsView, function (q) {
                    return _c("div", [
                      _c("p", { staticClass: "mt-5 mb-3 lead" }, [
                        _c("strong", [_vm._v(_vm._s(q.OrderValue) + ".")]),
                        _vm._v("\n                        How would you rate "),
                        _c("span", { staticClass: "text-lowercase" }, [
                          _vm._v(_vm._s(_vm.AlternativeLabel)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "text-primary font-italic",
                            on: { click: _vm.ShowAlternativeDetailsCommand },
                          },
                          [_vm._v(_vm._s(_vm.Name))]
                        ),
                        _vm._v("\n                        in the context of "),
                        _c(
                          "a",
                          {
                            staticClass: "text-primary",
                            on: {
                              click: function ($event) {
                                return _vm.ShowAttributeDetailsCommand(q)
                              },
                            },
                          },
                          [_vm._v(_vm._s(q.AttributeName))]
                        ),
                        _vm._v("?\n                    "),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-8" },
                          [
                            _c("SurveyVoteEditor", {
                              attrs: {
                                Value: q.Value,
                                Comment: q.Comment,
                                HasAnswer: q.HasAnswer,
                                HasScale: q.HasScale,
                                ScaleLevels: q.ScaleLevels,
                              },
                              on: {
                                "update-value": function ($event) {
                                  return _vm.handleVoteValueUpdate(q, $event)
                                },
                                "update-comment": function ($event) {
                                  return _vm.handleVoteCommentUpdate(q, $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ])
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }